import { render, staticRenderFns } from "./adjust-priorities.vue?vue&type=template&id=1fec52bc"
import script from "./adjust-priorities.vue?vue&type=script&lang=ts"
export * from "./adjust-priorities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports